const POSITION_STATUSES = [
  'published',
  'internal',
  'closed'
];

export default POSITION_STATUSES;
